module.exports = __webpack_public_path__ + "static/media/timelessoak.d9e82a59.svg";